import React from 'react';
import { useTranslation } from '../hooks/useTranslation.js';

const LanguageSwitcher = ({ className = '' }) => {
  const { currentLanguage, setLanguage } = useTranslation();

  const languages = [
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'pt', label: 'Português', flag: '🇵🇹' }
  ];

  return (
    <div className={`language-switcher ${className}`}>
      <style>{`
        .language-switcher {
          display: flex;
          gap: 0.4rem;
          align-items: center;
        }

        .lang-button {
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          padding: 0.4rem 0.55rem; /* narrower */
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 6px;
          background: rgba(255,255,255,0.04);
          color: rgba(255, 255, 255, 0.75);
          font-size: 0.75rem; /* slightly smaller */
          font-weight: 600;
          letter-spacing: .02em;
          cursor: pointer;
          transition: all 0.25s ease;
          min-width: 42px; /* keep compact */
        }

        .lang-button:hover {
          background: rgba(255, 255, 255, 0.12);
          color: #fff;
          border-color: rgba(255, 255, 255, 0.28);
        }

        .lang-button.active {
          background: linear-gradient(135deg, var(--ghost-accent-color,#6d28d9) 0%, #8b5cf6 100%);
          color: #fff;
          border-color: rgba(255,255,255,0.4);
          box-shadow: 0 2px 6px rgba(0,0,0,0.35);
        }

        .lang-flag { font-size: .9rem; }

        /* Tighten further in mobile command bar context */
        @media (max-width: 768px) {
          .language-switcher .lang-button { padding: 0.35rem 0.5rem; font-size: 0.7rem; min-width: 38px; }
        }
      `}</style>

      {languages.map((lang) => (
        <button
          key={lang.code}
          className={`lang-button ${currentLanguage === lang.code ? 'active' : ''}`}
          onClick={() => setLanguage(lang.code)}
          title={`Switch to ${lang.label}`}
        >
          <span className="lang-flag">{lang.flag}</span>
          <span>{lang.code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;